import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { getOS } from "../utils/os.js";
import { useInView } from "react-intersection-observer";

const WebpSupportCheck = (feature, callback) => {
  var kTestImages = {
    lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
  };
  var img = new Image();
  img.onload = function () {
    var result = img.width > 0 && img.height > 0;
    callback(feature, result);
  };
  img.onerror = function () {
    callback(feature, false);
  };
  img.src = "data:image/webp;base64," + kTestImages[feature];
};

const ImageLibpixel = ({ src, alt, mode, ...props }) => {
  const [isWebpSupported, setWebpSupported] = useState(undefined);
  const [imgSrc, setImgSrc] = useState(
    src?.includes("enklerevalg.no")
      ? "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
      : src
  );
  const imgRef = useRef();
  const { ref, inView } = useInView({
    rootMargin: "200px",
    threshold: 0,
    triggerOnce: true,
  });
  useEffect(() => {
    WebpSupportCheck("lossy", function (feature, isSupported) {
      if (isSupported) {
        setWebpSupported(true);
      } else {
        setWebpSupported(false);
      }
    });
  }, []);
  useEffect(() => {
    if (imgRef.current) {
      ref(imgRef.current);
    }
  }, [imgRef]);

  useEffect(() => {
    if (
      isWebpSupported !== undefined &&
      inView &&
      imgRef.current &&
      imgRef.current.clientWidth > 0 &&
      imgRef.current.clientHeight > 0
    ) {
      const os = getOS();
      const newSrc = src?.includes("enklerevalg.no")
        ? src
            .replace(
              "https://static.enklerevalg.no",
              "https://mev.libpx.com/eu-west-1/img"
            )
            .replace(
              "https://admin.enklerevalg.no",
              "https://mev.libpx.com/eu-west-1/enklere/img"
            )
        : src?.[0] === "2"
        ? "https://mev.libpx.com/eu-west-1/img/wp-content/uploads/${src}"
        : src;
      if (newSrc !== src) {
        const params = [
          `width=${imgRef.current.clientWidth}`,
          imgRef.current?.clientHeight
            ? `height=${imgRef.current.clientHeight}`
            : null,
          mode ? `mode=${mode}` : "mode=crop",
          os === "Windows" ? "dpr=2" : `dpr=${window.devicePixelRatio}`,
          isWebpSupported ? "format=webp" : null,
        ].filter((x) => Boolean(x));

        const query = params.length > 0 ? `?${params.join("&")}` : "";

        setImgSrc(`${newSrc}${query}`);
      }
    }
  }, [src, mode, imgRef, inView, isWebpSupported]);
  return <img ref={imgRef} src={imgSrc} alt={alt} {...props} />;
};

ImageLibpixel.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  mode: PropTypes.string,
};

export default ImageLibpixel;
